import orderInstance from '../../instance'

const deliveryDistanceGet = (data) => {
  return orderInstance.post('/customers/deliveryGeoData', data)
}

export default deliveryDistanceGet